import http from "./http";
export const createDiscount = (discount) =>
  http.post("/stores/discounts/create/", {
    code: discount.code,
    percent: discount.percent,
    expiry: discount.expiry,
    storeIds: discount.storeIds,
  });

export const getDiscount = (code) =>
  http.get("/stores/discounts", {
    params: {
      code,
    },
  });

export const updateDiscount = (discount) =>
  http.patch(`/stores/discounts/${discount.id}/update/`, {
    expired_at: discount.expiry,
    store_ids: discount.storeIds,
  });

export const checkDiscount = (discount) => {
  return http.post(`/stores/discounts/check/`, {
    code: discount.code,
    store_id: discount.storeId ?? null,
  });
};
